import { render } from "./BasePopup.vue?vue&type=template&id=087084e3&scoped=true"
import script from "./BasePopup.vue?vue&type=script&lang=js"
export * from "./BasePopup.vue?vue&type=script&lang=js"

import "./BasePopup.vue?vue&type=style&index=0&id=087084e3&lang=css&scoped=true"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087084e3"]])

export default __exports__